import React from 'react';
import { FieldConfigLabelSection } from './components/FieldConfigLabelSection';
import { FieldConfigStyleTypeSection } from './components/FieldConfigStyleTypeSection';
import { FieldConfigShowTitleSection } from './components/FieldConfigShowTitleSection';
import { FieldConfigExclusionsSection } from './components/FieldConfigExclusionsSection';
import {CONNECTOR} from "../../../../ISRConstants";

interface ConnectorConfigProps {
    label: string;
    onLabelChange: (value: string) => void;
    exclusionType: 'hide' | 'disable';
    onExclusionChange: (type: 'hide' | 'disable') => void;
    showTitle?: boolean;
    onShowTitleChange?: (value: boolean) => void;
    displayName?: string;
    onDisplayNameChange?: (value: string) => void;
}

const ConnectorConfig = ({ label, onLabelChange, exclusionType, onExclusionChange, showTitle = true, onShowTitleChange, displayName = '', onDisplayNameChange} : ConnectorConfigProps) => {
    return (
        <div>
            <FieldConfigLabelSection label={label} placeholderSuffix={CONNECTOR + " label"} />
            <FieldConfigStyleTypeSection fieldTypeName={CONNECTOR + ' Field'} />
            <FieldConfigShowTitleSection
                showTitle={showTitle}
                onShowTitleChange={onShowTitleChange}
                displayName={displayName}
                onDisplayNameChange={onDisplayNameChange}
            />
            <FieldConfigExclusionsSection
                exclusionType={exclusionType}
                onExclusionChange={onExclusionChange}
            />
        </div>
    );
};

export default ConnectorConfig;
